<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../../helpers/utilities';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { resolveSensorOffsetSetConfig } from '../../../../helpers/sensor_config_helpers';
	import { getNumberInputConfig } from '../../../../helpers/number_input_helpers';
	//Services
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Stores
	import { getDeviceStatus, readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../../types/Device';

	export let device: Device, setting: string;

	const id = real_id(device.id);
	const settings = readDeviceSettings(id);
	const localUnit = settings?.ht_ui?.temperature_unit || 'C';
	const valueAttr = `offset${setting == 'temperature' ? '_C' : ''}`;

	let min = -50;
	let max = 50;

	let value = settings?.[`${setting}:0`]?.[`${valueAttr}`];
	let unit = localUnit;
	let waitForResponse = false;

	const save = async () => {
		waitForResponse = true;

		const { method, params } = resolveSensorOffsetSetConfig(
			device,
			setting,
			settings,
			device.channel,
			valueAttr,
			value,
		);

		const res = await gen2Request(device, method, params);
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);

	const handleChange = (e) => {
		value = e.target.value;
	};
</script>

<Text styleType="body-small" class="mb-s"
	>{setting === 'temperature'
		? $format('text_sensor_settings_temperature', {
				values: { unit: unit },
				default: `Offset in °${unit} to be applied to the measured temperature.`,
			})
		: $format('text_sensor_settings_humidity', {
				default: `Humidity offset in %. Value is applied to measured humidity.`,
			})}</Text
>
<Input
	{...getNumberInputConfig()}
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	on:input={(e) => handleChange(e)}
	{value}
	info={inputData.info}
	error={inputData.error}
	step={1}
	id="input-rbt62jk"
	aria-label={$format('offset_wrapper_input', {
		default: 'Offset value',
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={inputData.error} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
